import { type AxiosRequestConfig } from 'axios'

const getConfig = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/config'
  }
}

export { getConfig }
